// extracted by mini-css-extract-plugin
export default {"landingPageContainer":"LandingPage_landingPageContainer__-6tsk"};